import type { EffectiveAccess } from "../services/authService";

/** DB-backed admin role codes from `effective_access.admin_roles` (verify snapshot). */
export const ADMIN_ROLE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  CONTRACT_ADMIN: "CONTRACT_ADMIN",
  RFP_ADMIN: "RFP_ADMIN",
  PRIZE_RULES_ADMIN: "PRIZE_RULES_ADMIN",
} as const;

function adminRolesUpper(adminRoles: readonly string[]): string[] {
  return adminRoles.map((r) => r.trim().toUpperCase());
}

export function hasSuperAdminRole(adminRoles: readonly string[]): boolean {
  return adminRolesUpper(adminRoles).includes(ADMIN_ROLE.SUPER_ADMIN);
}

/** ContractIQ hub and all `/contractiq/*` routes. */
export function canShowContractsModule(
  effectiveAccess: EffectiveAccess | null,
  adminRoles: readonly string[],
): boolean {
  if (hasSuperAdminRole(adminRoles)) return true;
  if (adminRolesUpper(adminRoles).includes(ADMIN_ROLE.CONTRACT_ADMIN)) return true;
  return effectiveAccess?.can_access_contracts === true;
}

/** PrizeLogic hub and all `/prizelogic/*` routes. */
export function canShowPrizeRulesModule(
  effectiveAccess: EffectiveAccess | null,
  adminRoles: readonly string[],
): boolean {
  if (hasSuperAdminRole(adminRoles)) return true;
  if (adminRolesUpper(adminRoles).includes(ADMIN_ROLE.PRIZE_RULES_ADMIN)) return true;
  return effectiveAccess?.can_access_prize_rules === true;
}

export function adminRolesFromAccess(effectiveAccess: EffectiveAccess | null): readonly string[] {
  return effectiveAccess?.admin_roles ?? [];
}
